import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  firstNameLegal: Yup.string().required('This field is required'),
  lastNameLegal: Yup.string().required('This field is required'),
  address1: Yup.string().nullable(),
  address2: Yup.string().nullable(),
  city: Yup.string().nullable(),
  zip: Yup.string().nullable(),
  state: Yup.string().nullable(),
  idType: Yup.string().nullable(),
  licenseNumber: Yup.string().nullable(),
  licenseExpiration: Yup.mixed().nullable(),
  height: Yup.string().nullable(),
  eyes: Yup.string().nullable(),
  hair: Yup.string().nullable(),
  gender: Yup.string().nullable(),
  birthDate: Yup.mixed().nullable(),
  licenseImage: Yup.string().nullable(),
  licenseImageBack: Yup.string().nullable(),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
